import React from 'react'
import Feature2 from '../../components/Feature2';
import { graphql, StaticQuery, Link, navigate } from 'gatsby';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { getImage } from '../../utils';
import { MONTHS } from '../../constants';
import Truncate from 'react-truncate';

const Item = ({
    title,
    image,
    alt,
    slug
}) => {
    const goTo = () =>
        navigate(slug)

    return (
        <div
            onClick={goTo}
            style={{
                borderTopLeftRadius: "2rem",
                borderTopRightRadius: "2rem",
                borderBottomLeftRadius: "2rem",
                borderBottomRightRadius: "2rem",
            }}
            className="c-pointer opacity to-scale-with-animation bg-white">
            <img
                style={{
                    borderTopLeftRadius: "2rem",
                    borderTopRightRadius: "2rem",
                    height: "240px",
                    objectFit: "cover"
                }}
                src={image}
                alt={alt}
                className="img-fluid w-100" />
            <div
                style={{ 
                    height: "150px",
                    borderBottomLeftRadius: "2rem",
                    borderBottomRightRadius: "2rem",
                 }}
                className="bg-white p-3 font-weight-bold">
                    <Truncate trimWhitespace={true} lines={3} ellipsis={<span>...</span>}>
                        {title}
                    </Truncate>
            </div>
        </div>
    )
}

const BlogSection = ({
    data
}) => {
    console.log('data :>> ', data);
    const posts = data.allMarkdownRemark.edges;

    const getClassByLength = (len, index) => {
        if (len === 1)
            return "offset-md-3 offset-lg-4"
        else if (len === 2 && index < len)
            return "offset-md-1 offset-lg-2"
        else if (len === 3)
            return "mb-3 mb-lg-0";
    }

    return (
        <>
            <section
                id="blog"
                className="container-fluid py-5 bg-1">
                <div className="container container-max">
                    <h3 className="text-center font-weight-bold text-white">
                        BLOG
                    </h3>
                    {/* Displayed in desk */}
                    <div className="d-none d-md-block">
                        <div className="row mt-5 pb-4">
                            {
                                posts.map((item, index) => {
                                    console.log('item :>> ', item);
                                    return (
                                        <div
                                            key={`postdesktop${index}`}
                                            className={`col-md-6 col-lg-4 ${getClassByLength(posts.length, index + 1)}`}>
                                            <Item
                                                image={getImage(item.node.frontmatter, "featuredimage")}
                                                title={item.node.frontmatter.title}
                                                slug={item.node.fields.slug} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {/* Displayed in mobile */}
                    <div className="d-block d-md-none">
                        <Carousel showStatus={false} showThumbs={false} emulateTouch>
                            {
                                posts.map((item, index) => (
                                    <div
                                        style={{ backgroundColor: "transparent" }}
                                        className="px-md-0 pb-5">
                                        <div
                                            key={`propmobile${index}`}>
                                            <Item
                                                image={getImage(item.node.frontmatter, "featuredimage")}
                                                title={item.node.frontmatter.title}
                                                slug={item.node.fields.slug} />
                                        </div>
                                    </div>
                                ))
                            }
                        </Carousel>
                    </div>
                </div>
            </section>
        </>
    )
}

export default props => (
    <StaticQuery
        query={graphql`
        query BlogSection {
            allMarkdownRemark(
                sort: { order: DESC, fields: [frontmatter___date] }
                filter: { frontmatter: { templateKey: { eq: "blog-post" } }}
                limit: 3
            ) {
                edges {
                    node {
                        fields {
                            slug
                        }
                        frontmatter {
                            title
                            featuredimage {
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                            }
                            altFeatured
                        }
                    }
                }
            }
        }
      `}
        render={(data, count) => <BlogSection data={data} count={count} title="BLOG" {...props} />}
    />
)